import wiFi from "@images/svg/wi-fi.svg";
import eTicket from "@images/svg/e-ticket.svg";
import seatbelt from "@images/svg/seatbelt.svg";
import freeMask from "@images/svg/free-mask.svg";
import sanitizer from "@images/svg/sanitizer.svg";
import climateControl from "@images/svg/climate-control.svg";
import wc from "@images/svg/wc.svg";

import { blocksOptionsConfig, newCollectionTemplate } from "@components/cmsBlocks/configs";
export const collectionType = blocksOptionsConfig.collectionTypes.features.value;

export const config = newCollectionTemplate({
  typeFields: {
    title: "text",
  },
  itemTemplate: {
    title: "",
  },
  type: collectionType,
  showAsTitle: "title", // only texts fields
  allowUseSets: false,
})

// export const config1 = {
//   typeFields: {
//     title: "text",
//   },
//   itemTemplate: {
//     title: "",
//   },
//   type: collectionType,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: false,
// };

export const initBlockData = {
  title: "Travelling with Lux Express",
  blockTitle1: 'Quality time',
  blockContent1: '<p>We offer our passengers priceless quality time, something we are all constantly short of.</p>',
  blockTitle2: 'Comfort class',
  blockContent2: '<p>Sleep, read, watch movies or houses passing by in our spacious seats with legroom like no other and AC always keeping you cool.</p>',
  blockTitle3: 'Comfort class',
  blockContent3: '<p>Individual multimedia screen makes the trip more enjoyable. As they say - time flies when you\'re having fun.</p>',
  blockTitle4: 'Internet and 220V',
  blockContent4: '<p>Free Wi-Fi and power outlets by every seat help you stay connected on the road and give freedom to spend that quality time however you prefer.</p>',
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  }
};

export const initEmptyBlockData = {
  title: "",
  blockTitle1: '',
  blockContent1: '',
  blockTitle2: '',
  blockContent2: '',
  blockTitle3: '',
  blockContent3: '',
  blockTitle4: '',
  blockContent4: '',
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  }
};

export const iconsData = {
  freeWifi: {
    label: 'free wifi',
    src: wiFi,
  },
  eTicket: {
    label: 'e-ticket',
    src: eTicket,
  },
  seatbelt: {
    label: 'seatbelt',
    src: seatbelt,
  },
  restroom: {
    label: 'restroom',
    src: wc,
  },
  freeMask: {
    label: 'free mask',
    src: freeMask,
  },
  sanitizer: {
    label: 'hand sanitizers',
    src: sanitizer,
  },
  climateControl: {
    label: 'climate',
    src: climateControl,
  },
}